// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-campaign {
  padding: 0px;
}
.content-campaign svg {
  color: #40c3fe;
  margin-right: 15px;
}
.content-campaign .content-input-search {
  border: 2px solid #6d68aa;
  border-radius: 50rem;
  padding: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
  background: white;
}
.content-campaign .content-input-search svg {
  color: #6d68aa;
  margin: 0 5px;
}
.content-campaign .content-input-search input {
  border-radius: 0;
  border: none;
  height: 25px;
  width: 100%;
  margin: 0;
  padding: 0 10px;
}
.content-campaign select {
  border: 2px solid #6d68aa;
  border-radius: 50rem;
  padding: 0;
  margin: 0 5px;
  background: white;
  height: 29px;
  width: 100%;
}
.content-campaign ul.scrolling {
  height: calc(100vh - 428px);
  overflow: hidden;
  overflow-y: auto;
}
.content-campaign ul.scrolling li {
  padding: 10px 0;
  border-bottom: 1px solid #cfcfcf;
}
.content-campaign ul.scrolling li:hover {
  background: rgba(0, 0, 0, 0.05);
}
.content-campaign ul.scrolling li div {
  color: #9a9a9a;
}
.content-campaign ul.scrolling li.active div {
  color: #3a3a3a;
  font-weight: bold;
}
.content-campaign ul.header {
  padding-bottom: 0;
  padding-right: 0;
  margin: 0;
  color: #afafaf;
  font-size: 14px;
  overflow: hidden;
}
.content-campaign ul.header li {
  border-bottom: 2px solid #cfcfcf;
}
.content-campaign .btn-send-campaign {
  background: #7B6BE4;
  color: #fff;
  font-weight: bold;
  border-radius: 20px !important;
  width: 120px;
  padding: 8px 20px;
  border: none;
}
.content-campaign .assign-custom-checkbox {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.content-campaign .checkmark {
  padding: 6px 10px;
  display: block;
  height: 25px;
  width: 25px;
  background-color: #d9d9e2;
}
.content-campaign .assign-custom-checkbox:checked ~ .checkmark {
  background-color: #41c8ff;
}
.content-campaign .checkmark:after {
  content: " ";
  display: none;
}
.content-campaign .assign-custom-checkbox:checked ~ .checkmark:after {
  display: block;
}
.content-campaign .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.swal2-actions button {
  border-radius: 20px !important;
  width: 120px;
  padding: 8px 20px;
}`, "",{"version":3,"sources":["webpack://./src/Views/Campaign/campaign.sass"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,cAAA;EACA,kBAAA;AACR;AACI;EACI,yBAAA;EACA,oBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AACR;AACQ;EACI,cAAA;EACA,aAAA;AACZ;AACQ;EACI,gBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AACZ;AACI;EACI,yBAAA;EACA,oBAAA;EACA,UAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AACR;AACI;EACI,2BAAA;EACA,gBAAA;EACA,gBAAA;AACR;AACQ;EACI,eAAA;EACA,gCAAA;AACZ;AAAY;EACI,+BAAA;AAEhB;AADY;EACI,cAAA;AAGhB;AADQ;EACI,cAAA;EACA,iBAAA;AAGZ;AADI;EACI,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAGR;AADQ;EACI,gCAAA;AAGZ;AADI;EACI,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,8BAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AAGR;AADI;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AAGR;AADI;EACI,iBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AAGR;AADI;EACQ,yBAAA;AAGZ;AADI;EACI,YAAA;EACA,aAAA;AAGR;AADI;EACI,cAAA;AAGR;AADI;EACI,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EAGA,wBAAA;AAGR;;AADA;EACI,8BAAA;EACA,YAAA;EACA,iBAAA;AAIJ","sourcesContent":[".content-campaign\n    padding: 0px\n\n    & svg\n        color: #40c3fe\n        margin-right: 15px\n\n    .content-input-search\n        border: 2px solid #6d68aa\n        border-radius: 50rem\n        padding: 0\n        display: flex\n        align-items: center\n        overflow: hidden\n        background: white\n\n        & svg\n            color: #6d68aa\n            margin: 0 5px\n\n        input\n            border-radius: 0\n            border: none\n            height: 25px\n            width: 100%\n            margin: 0\n            padding: 0 10px\n\n    select\n        border: 2px solid #6d68aa\n        border-radius: 50rem\n        padding: 0\n        margin: 0 5px\n        background: white\n        height: 29px\n        width: 100%\n\n    ul.scrolling\n        height: calc(100vh - 428px)\n        overflow: hidden\n        overflow-y: auto\n\n        & li\n            padding: 10px 0\n            border-bottom: 1px solid #cfcfcf\n            &:hover\n                background: rgba(0,0,0,.05)\n            & div\n                color: #9a9a9a\n\n        & li.active div\n            color: #3a3a3a\n            font-weight: bold\n\n    ul.header\n        padding-bottom: 0\n        padding-right: 0\n        margin: 0\n        color: #afafaf\n        font-size: 14px\n        overflow: hidden\n\n        & li\n            border-bottom: 2px solid #cfcfcf\n\n    & .btn-send-campaign \n        background: #7B6BE4\n        color: #fff\n        font-weight: bold\n        border-radius: 20px !important\n        width: 120px\n        padding: 8px 20px\n        border: none\n\n    & .assign-custom-checkbox\n        position: absolute\n        opacity: 0\n        cursor: pointer\n        height: 0\n        width: 0\n\n    & .checkmark \n        padding: 6px 10px\n        display: block\n        height: 25px\n        width: 25px\n        background-color: #d9d9e2\n\n    & .assign-custom-checkbox:checked ~ .checkmark\n            background-color: #41c8ff \n\n    & .checkmark:after\n        content: \" \"\n        display: none\n\n    & .assign-custom-checkbox:checked ~ .checkmark:after\n        display: block\n\n    & .checkmark:after\n        left: 9px\n        top: 5px\n        width: 5px\n        height: 10px\n        border: solid white\n        border-width: 0 3px 3px 0\n        -webkit-transform: rotate(45deg)\n        -ms-transform: rotate(45deg)\n        transform: rotate(45deg)\n\n.swal2-actions button\n    border-radius: 20px !important\n    width: 120px\n    padding: 8px 20px\n\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
